import React from "react";
import cx from "classnames";
import checkMarkSvg from "../assets/check-mark.svg";

const Segment = ({
  label,
  itemIndex,
  activeIndex,
}: {
  label: string;
  itemIndex: number;
  activeIndex: number;
}) => {
  const isActive = itemIndex <= activeIndex;
  return (
    <div
      className={cx({
        "gpc__shipment-line__progress-bar__item": true,
        active: isActive,
      })}
    >
      {label}{" "}
      {isActive && (
        <img
          className="checkmark-icon"
          src={checkMarkSvg}
          alt={`${label} checked`}
        />
      )}
    </div>
  );
};

interface Props {
  stateLabels: string[];
  currentStateIndex: 0 | 1 | 2;
}

const OrderProgressBar = ({ stateLabels, currentStateIndex = 0 }: Props) => {
  return (
    <div className="gpc__shipment-line">
      <div className="gpc__shipment-line__progress-bar">
        {stateLabels.map((label, index) => (
          <Segment
            label={label}
            itemIndex={index}
            activeIndex={currentStateIndex}
            key={`${label}-${index}`}
          />
        ))}
      </div>
    </div>
  );
};

export default OrderProgressBar;
